/* TODO: Just use a flex box directly? */
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
}
